import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

const organizationSchema = z.object({
  id: z.number(),
  amazon_profile_name: z.string(),
  org_type: z.string(),
});
const userSchema = z
  .object({
    id: z.number(),
  })
  .nullable();
const companyObject = z.object({
  id: z.number(),
  company_id: z.string(),
  name: z.string(),
  organization: organizationSchema,
});

const contactObject = z.object({
  id: z.number(),
  first_name: z.string(),
  last_name: z.string(),
  email: z.string(),
});
const ownerObject = z.object({
  id: z.number(),
  owner_id: z.string(),
  first_name: z.string(),
  last_name: z.string(),
  email: z.string(),
  user: userSchema,
});

const notesObject = z.object({
  id: z.number(),
  note_id: z.string(),
  body: z.string(),
  ticket: z.number(),
});

const tasksObject = z.object({
  id: z.number(),
  task_id: z.string(),
  subject: z.string(),
  body: z.string(),
  // link:z.array(z.string()),
  ticket: z.number(),
});

const reviewObject = z.object({
  id: z.number(),
  response: z.string(),
  messages: z.string(),
  ticket: z.number(),
});

const ticketSchema = z.object({
  id: z.number(),
  ticket_id: z.string(),
  priority: z.string(),
  status: z.string(),
  content: z.string(),
  subject: z.string(),
  company: companyObject,
  contact: contactObject,
  owner: ownerObject,
  notes: z.array(notesObject),
  tasks: z.array(tasksObject),
  bot_responses: z.array(reviewObject),
});
export type HubspotTicket = z.infer<typeof ticketSchema>;

export const ticketsApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "getTickets",
    method: "get",
    path: "/tickets",
    status: 200,
    response: z.array(ticketSchema),
  }).build(),
);

export const exportCsvEndpoint = prefixApi(
  "/api",
  apiBuilder({
    alias: "exportTicketsCsv",
    method: "get",
    path: "/export_ticketscsv",
    response: z.any(),
  }).build(),
);
